"use strict";
var StateSellingAbility = (function () {
    function StateSellingAbility(isoCode2, name, canSell) {
        this.isoCode2 = isoCode2;
        this.name = name;
        this.canSell = canSell;
    }
    return StateSellingAbility;
}());
exports.StateSellingAbility = StateSellingAbility;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/state-selling-ability.model.js